import { render } from "./SabyIntegrationSwitcher.vue?vue&type=template&id=12ea0bb4&scoped=true"
import script from "./SabyIntegrationSwitcher.vue?vue&type=script&lang=js"
export * from "./SabyIntegrationSwitcher.vue?vue&type=script&lang=js"

import "./SabyIntegrationSwitcher.vue?vue&type=style&index=0&id=12ea0bb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ea0bb4"]])

export default __exports__